import { render } from "./AnnouncementUpload.vue?vue&type=template&id=cc531c80&scoped=true&ts=true"
import script from "./AnnouncementUpload.ts?vue&type=script&lang=ts"
export * from "./AnnouncementUpload.ts?vue&type=script&lang=ts"

import "./AnnouncementUpload.scss?vue&type=style&index=0&id=cc531c80&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc531c80"]])

export default __exports__